module.exports = __webpack_public_path__ + "static/media/banner2_m.ee84eb07.png";